import { DesktopOutlined } from "@ant-design/icons";
import {
  AdminForgotPassword,
  AdminLogin,
  AdminOtpVerification,
  AdminResetPassword,
  SupportPage,
  UserCalorie,
  // PublicUserNutritionDetails,
} from "pages";

import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for admin authentication-related pages.
 * @returns {Array} An array containing route objects for admin authentication pages.
 */
export default function route() {
  // Define a reusable icon for the routes
  const routeIcon = <DesktopOutlined />;
  return [
    // Admin Login Route
    {
      path: adminRouteMap.LOGIN.path,
      name: "Admin Login",
      key: adminRouteMap.LOGIN.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminLogin />,
    },
    // Admin Forgot Password Route
    {
      path: adminRouteMap.FORGOT_PASSWORD.path,
      name: "Admin Forgot Password",
      key: adminRouteMap.FORGOT_PASSWORD.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminForgotPassword />,
    },
    // Admin Reset Password Route
    {
      path: adminRouteMap.RESET_PASSWORD.path,
      name: "Admin Reset Password",
      key: adminRouteMap.RESET_PASSWORD.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminResetPassword />,
    },
    // Admin OTP Verification Route
    {
      path: adminRouteMap.OTP_VERIFICATION.path,
      name: "Admin OTP Verification",
      key: adminRouteMap.OTP_VERIFICATION.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminOtpVerification />,
    },
    {
      path: adminRouteMap.SUPPORT.path,  // URL path for the dashboard
      name: "Support",  // Display name for the route
      key: adminRouteMap.SUPPORT.path,  // Unique key for the route
      private: false,  // Requires authentication to access
      belongsToSidebar: false,  // Appears in the admin sidebar
      // icon: adminRouteMap.DASHBOARD.icon,  // Icon associated with the dashboard
      element: <SupportPage />,  // Component to render for this route
    },
    // User Calorie logs page
    {
      path: adminRouteMap.USER_CALORIE_LOGS.path,
      name: "User Calorie Logs",
      key: adminRouteMap.USER_CALORIE_LOGS.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <UserCalorie />,
    },
    // {
    //   path: `${adminRouteMap.USER_CALORIE_DETAILS.path}/:id`,
    //   name: "User Nutrition Details",
    //   key: `${adminRouteMap.USER_CALORIE_DETAILS.path}/:id`,
    //   private: false, // Public route, accessible without authentication
    //   belongsToSidebar: false,
    //   icon: routeIcon,
    //   element: <PublicUserNutritionDetails />,
    // },
  ];
}
